import { RGB } from '../models';

/**
 * Converts a hex color to an RGB tuple.
 */
export function hexToRgb(hex: string): RGB {
  const hexValue = hex.replace('#', '');

  return [parseInt(hexValue.substring(0, 2), 16), parseInt(hexValue.substring(2, 4), 16), parseInt(hexValue.substring(4, 6), 16)];
}
